"use client";
import React, { createContext, useContext, useState } from "react";
import { BASE_URL } from "../config/apiconfig";

const RefundContext = createContext();

export const RefundProvider = ({ children }) => {

  const [loading, setLoading] = useState(false);

  const token =
    typeof window !== "undefined"
      ? localStorage.getItem("token")
      : null;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  /* =====================
        CREATE REFUND
  ===================== */
  const createRefund = async (payload) => {
    setLoading(true);

    try {
      const res = await fetch(`${BASE_URL}/refund`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          order_id: payload.order_id,
          refund_amount: payload.refund_amount,
          refund_transaction_id: payload.refund_transaction_id,
        }),
      });

      return await res.json();

    } catch (error) {
      return { status: false, message: "Refund creation failed" };
    } finally {
      setLoading(false);
    }
  };

  return (
    <RefundContext.Provider
      value={{
        createRefund,
        loading,
      }}
    >
      {children}
    </RefundContext.Provider>
  );
};

export const useRefund = () => useContext(RefundContext);